/**
 * 设置表格特定列的对齐方式
 * 
 * @param tableData 表格数据
 * @param columnIndex 列索引或列索引数组
 * @param alignment 对齐方式 ('left', 'center', 'right')
 * @param skipHeaderRow 是否跳过表头行 (默认为true)
 * @returns 处理后的表格数据
 */
export function setColumnAlignment(
  tableData: any[][],
  columnIndex: number | number[],
  alignment: "left" | "center" | "right" = "left",
  skipHeaderRow: boolean = true
): any[][] {
  // 参数验证
  if (!tableData || !tableData.length) {
    return tableData;
  }

  // 转换单个列索引为数组
  const columnsToAlign: number[] = Array.isArray(columnIndex)
    ? columnIndex
    : [columnIndex];

  // 深拷贝表格数据
  const result = JSON.parse(JSON.stringify(tableData));

  // 遍历每一行
  for (let rowIndex = 0; rowIndex < result.length; rowIndex++) {
    // 跳过表头行（如果指定）
    if (skipHeaderRow && rowIndex === 0) {
      continue;
    }

    const row = result[rowIndex];

    // 处理指定的每一列
    columnsToAlign.forEach((colIndex) => {
      // 确保列索引有效
      if (colIndex < 0 || colIndex >= row.length) {
        return; // 跳过无效列索引
      }

      const cell = row[colIndex];

      // 跳过空单元格
      if (cell === null || cell === undefined) {
        return;
      }

      // 处理单元格
      if (typeof cell === "object" && cell !== null) {
        // 设置单元格对齐方式
        cell.alignment = alignment;
      } else {
        // 将简单值转换为对象
        row[colIndex] = {
          text: String(cell), // 确保转换为字符串
          alignment: alignment
        };
      }
    });
  }

  return result;
}
